/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:center}h3[_ngcontent-%COMP%]{line-height:1.2}ui-input[_ngcontent-%COMP%]    {margin:23px 0 32px}ui-input[_ngcontent-%COMP%]     .placeholder{font-size:16px}ui-input[_ngcontent-%COMP%]     textarea{width:460px;height:144px;min-width:300px;min-height:50px}"];
export { styles as styles };
